import { Injectable } from '@angular/core';
import { FichaTecnicaEpp, FichaTecnicaEppUpdate } from '../entities/ficha-tecnica-epp';
import { CRUDService } from '../../core/services/crud.service';

@Injectable({
  providedIn: 'root'
})
export class FichaTecnicaEppService extends CRUDService<FichaTecnicaEpp>{
  
  
  getClassName(): string {
    return "FichaTecnicaEppService";
  }

  finById(id: number) {
    return this.httpInt.get(`${this.end_point}findById/${id}`);
  }

  updateFichaTecnicaEpp(fichaTecnicaEpp: FichaTecnicaEppUpdate) {
    return this.httpInt.put(`${this.end_point}`, fichaTecnicaEpp);
  }

  getAllCargos(){
    return this.httpInt.get(`${this.end_point}cargo/`);

  }
}
